<template>
  <RkTable :data="equityChangeData" :loading="loading" :finished="finished">
    <RkTableColumn prop="changeDate" label="变动日期" align="left" :width="`${postcssPatch(100)}`">
      <template slot-scope="{ row }">{{ $digitjs(row.changeDate).isNull() }}</template>
    </RkTableColumn>
    <RkTableColumn prop="issuedShare" label="已发行普通股(股)">
      <template slot-scope="{ row }">{{ $digitjs(row.issueNormal).convert() }}</template>
    </RkTableColumn>
    <RkTableColumn prop="changeReason" label="变动原因">
      <template slot-scope="{ row }">{{ $t($digitjs(row.changeReason).isNull()) }}</template>
    </RkTableColumn>
  </RkTable>
</template>

<script>
import { postcssPatch } from '@/utils/postcssPatch'

export default {
  data() {
    return {
      loading: false,
      finished: false,
      equityChangeData: []
    }
  },
  computed: {
    symbol() {
      return this.$route.query.symbol
    }
  },
  created() {
    this.getHoldChangeData()
  },
  methods: {
    postcssPatch,
    async getHoldChangeData() {
      this.loading = true
      const res = await this.$post(this.$api.f10.us + '/summary/hold-change', {
        symbol: this.symbol
      })
      const data = res.data ?? []
      this.equityChangeData = [...this.equityChangeData, ...data]
      this.loading = false
      this.finished = true
    }
  }
}
</script>
